import React from "react";

import Link from "next/link";
import { cn } from "@/lib/utils";
import { resolvePageLink } from "@/sanity/globals/CTA";
import { IFooter } from "@/sanity/lib/definitions";
import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";

export default function Footer({
  data,
  className,
  slug,
  alternativeRiskDisclosure = false,
  isBeyondBoring = false,
}: {
  data: IFooter;
  className?: string;
  slug?: string;
  alternativeRiskDisclosure?: boolean;
  isBeyondBoring?: boolean;
}) {
  const isBrazil = slug?.endsWith("/br");
  return (
    <footer
      className={cn(
        "w-full px-[2rem] lg:px-[5rem] py-[3rem] lg:py-[4rem] flex flex-col gap-[4rem] lg:gap-[2rem]",
        className,
      )}
    >
      <div className="flex flex-col lg:flex-row items-center lg:justify-between gap-[1.5rem] w-[min(229.25rem,100%)] mx-auto">
        <p className="mb-0 text-[1.75rem] text-[#141719]/8">
          © {new Date().getFullYear()} {isBeyondBoring ? "Beyond IQ Capital" : "IQ Capital"} -{" "}
          {isBrazil ? "Todos os direitos reservados" : "All rights reserved"}
        </p>

        {data?.menuItems && (
          <div className="flex flex-wrap justify-center items-center gap-[1.5rem]">
            {data.menuItems.map((item, index) => (
              <React.Fragment key={index}>
                <Link
                  className="opacity-80 transition-opacity hover:opacity-100 text-[#454748] text-[1.75rem]"
                  href={resolvePageLink(item.link) ?? "/"}
                  target={item.link.openInNewTab ? "_blank" : "_self"}
                >
                  {item.title}
                </Link>

                {index < data.menuItems.length - 1 && (
                  <span className="opacity-80 text-[#454748] text-[1.75rem]">
                    /
                  </span>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
      {data?.riskDisclosure && (
        <div
          className={cn(
            "richtext richtext-start riskdisclosure prose-p:text-[#454748]/80 prose-p:text-[1.75rem]",
            alternativeRiskDisclosure
              ? "bg-[#F9F9F9] prose-p:text-[#454748]/60 rounded-[2rem] lg:rounded-[5.25rem] px-[2rem] py-[4rem] lg:py-[5rem] lg:richtext-center lg:[text-wrap-style:balance] lg:prose-p:max-w-[97.5rem]"
              : "",
          )}
        >
          <PortableText
            value={data?.riskDisclosure}
            components={richTextComponent}
          />
        </div>
      )}
    </footer>
  );
}
